import React from 'react';
import AboutHero from '../components/AboutHero/AboutHero';
import MissionSection from '../components/MissionSection/MissionSection';
import ValuesSection from '../components/ValuesSection/ValuesSection';
import './AboutSystem.css';
import { Footer } from '../components';

const AboutSystem = () => {
  return (
    <div className="about-system">
      <AboutHero />
      <MissionSection />
      <Footer />
    </div>
  );
};

export default AboutSystem; 